export default function Marquee({ items = [], variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <div
      data-testid="marquee"
      className={`relative overflow-hidden border-y ${
        isDark ? "border-white/10 bg-[#2A1E17]" : "border-[#E8D8C8] bg-[#F3EBE1]"
      } py-8`}
    >
      <div className="marquee-track flex gap-16 whitespace-nowrap will-change-transform w-max">
        {[...items, ...items, ...items].map((t, i) => (
          <span
            key={i}
            className={`font-serif-display italic text-3xl sm:text-5xl ${
              isDark ? "text-[#FAF7F2]" : "text-[#4A3320]"
            }`}
          >
            {t}
            <span className={`mx-8 ${isDark ? "text-[#D4A373]" : "text-[#C76D4B]"}`}>·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
